@if (!selectedItemsLoaded) {
<div class="modal-content-container">
  <se-fe-spinner [seFeDataSize]="900" [seFeDataCenter]="true"></se-fe-spinner>
</div>
}

@if (selectedItemsLoaded) {
<div>
<se-fe-grid seFeGridOpts="snug right middle">
  <se-fe-grid-cell seFeGridOpts="shrink">
    <se-fe-modal-button
      [seFeDataButton]="{
        label: 'SALE_ITEM_SELECTOR.open_modal_button' | translate,
        secondary: true
      }"
      (seFeButtonAction)="modal.open($event)">
    </se-fe-modal-button>
  </se-fe-grid-cell>
  <se-fe-grid-cell seFeGridOpts>
    <span class="text-help"
          [translate]="'SALE_ITEM_SELECTOR.amount_selected'"
          [translateParams]="{ amountSelected: this.amountSelected }"
    ></span>
  </se-fe-grid-cell>
</se-fe-grid>

<div [hidden]="this.amountSelected < 1">
  <se-fe-grid seFeGridOpts>
    <se-fe-grid-cell seFeGridOpts>
      <div class="display-table-container">
        <table #displayTable seFeTable
               [title]="'SALE_ITEM_SELECTOR.ITEM_TABLE.display_table_label' | translate">

          <ng-container seFeColumnDef="name">
            <th seFeHeaderCell seFeDataRef="name" *seFeHeaderCellDef class="name-col">
              {{ 'SALE_ITEM_SELECTOR.ITEM_TABLE.name_header' | translate }}
            </th>
            <td seFeCell *seFeCellDef="let row">{{ row.full_name }}</td>
          </ng-container>

          <ng-container seFeColumnDef="sku">
            <th seFeHeaderCell seFeDataRef="sku" *seFeHeaderCellDef class="sku-col">
              {{ 'SALE_ITEM_SELECTOR.ITEM_TABLE.sku_header' | translate }}
            </th>
            <td seFeCell *seFeCellDef="let row">{{ row.sku }}</td>
          </ng-container>

          <ng-container seFeColumnDef="price">
            <th seFeHeaderCell seFeDataRef="price" *seFeHeaderCellDef class="price-col text-right">
              {{ 'SALE_ITEM_SELECTOR.ITEM_TABLE.price_header' | translate }}
            </th>
            <td seFeCell *seFeCellDef="let row" class="text-right">{{ row.price | currency }}</td>
          </ng-container>

          <ng-container seFeColumnDef="remove">
            <th seFeHeaderCell *seFeHeaderCellDef class="remove-col"></th>
            <td seFeCell *seFeCellDef="let row" width="10">
              <se-fe-button [seFeDataEmphasis]="'medium'" (click)="removeItem(row.id)">Remove</se-fe-button>
            </td>
          </ng-container>

          <tr seFeHeaderRow *seFeHeaderRowDef="displayTableColumns.value; sticky: false"></tr>
          <tr seFeRow *seFeRowDef="let row; columns: displayTableColumns.value"></tr>

        </table>
      </div>
      <div class="number-selected">
        {{ 'SALE_ITEM_SELECTOR.number_selected.'+(this.amountSelected === 1 ? 'one' : 'plural') | translate:{amountSelected: this.amountSelected} }}
      </div>
    </se-fe-grid-cell>
  </se-fe-grid>
</div>

<se-fe-modal #modal seFeDataSize="large">
  <div seFeModalHeader>
    <se-fe-modal-header
      [seFeDataTitle]="'SALE_ITEM_SELECTOR.SELECT_ITEM_MODAL.title' | translate"
      (seFeButtonAction)="this.resetSelection()">
    </se-fe-modal-header>
  </div>

  <div seFeModalContent>
    <se-fe-grid seFeGridOpts>
      <se-fe-grid-cell seFeGridOpts>
        <div>{{ modalHeader }}</div>
      </se-fe-grid-cell>
    </se-fe-grid>
    <se-fe-grid seFeGridOpts>
      <se-fe-grid-cell seFeGridOpts>
        <se-fe-toolbar
          [seFeDataQuery]="searchTerm"
          (seFeQueryChange)="search($event)"
          seFeDataSearchDebounce=1000
        ></se-fe-toolbar>
        @if (!isLoaded) {
<div class="modal-content-container">
          <se-fe-spinner [seFeDataSize]="900" [seFeDataCenter]="true"></se-fe-spinner>
        </div>
}
        <div [hidden]="!isLoaded || itemVariationList.length" class="modal-content-container">
          <se-fe-empty-state
            [seFeDataTitle]="'SALE_ITEM_SELECTOR.SELECT_ITEM_MODAL.EMPTY_STATE.title' | translate"
            seFeDataSize="500">
            {{ 'SALE_ITEM_SELECTOR.SELECT_ITEM_MODAL.EMPTY_STATE.description' | translate }}
          </se-fe-empty-state>
        </div>
        @if (selectForm) {
<form [formGroup]="selectForm">
          @if (isLoaded && itemVariationList.length) {
<div>
            <table #selectTable seFeTable
                   [title]="'SALE_ITEM_SELECTOR.ITEM_TABLE.select_table_label' | translate">

              <ng-container seFeColumnDef="checkbox">
                <th seFeHeaderCell *seFeHeaderCellDef></th>
                <td seFeCell *seFeCellDef="let row" width="0" class="selected-item-form__checkbox">
                  <input [formControlName]="row.id" type="checkbox" />
                </td>
              </ng-container>

              <ng-container seFeColumnDef="name">
                <th seFeHeaderCell seFeDataRef="name" *seFeHeaderCellDef>
                  {{ 'SALE_ITEM_SELECTOR.ITEM_TABLE.name_header' | translate }}
                </th>
                <td seFeCell *seFeCellDef="let row">{{ row.full_name }}</td>
              </ng-container>

              <ng-container seFeColumnDef="sku">
                <th seFeHeaderCell seFeDataRef="sku" *seFeHeaderCellDef>
                  {{ 'SALE_ITEM_SELECTOR.ITEM_TABLE.sku_header' | translate }}
                </th>
                <td seFeCell *seFeCellDef="let row">{{ row.sku }}</td>
              </ng-container>

              <ng-container seFeColumnDef="price">
                <th seFeHeaderCell seFeDataRef="price" *seFeHeaderCellDef class="text-right">
                  {{ 'SALE_ITEM_SELECTOR.ITEM_TABLE.price_header' | translate }}
                </th>
                <td seFeCell *seFeCellDef="let row" class="text-right">{{ row.price | currency }}</td>
              </ng-container>

              <tr seFeHeaderRow *seFeHeaderRowDef="selectTableColumns.value; sticky: false"></tr>
              <tr seFeRow (click)="clickRow($event)" *seFeRowDef="let row; columns: selectTableColumns.value"></tr>

            </table>
            @if (isLoaded) {
<se-fe-pagination

              [seFeDataPaginationOptions]="paginationOptions"
              (seFePaginationChange)="handlePagination($event)">
            </se-fe-pagination>
}
          </div>
}
        </form>
}
      </se-fe-grid-cell>
    </se-fe-grid>
  </div>

  <div seFeModalFooter>
    <div class="se-fe-modal-footer">
      <se-fe-grid seFeGridOpts="snug right middle">
        <se-fe-grid-cell seFeGridOpts>
          <div
            class="text-right text-help"
            [translate]="'SALE_ITEM_SELECTOR.amount_selected'"
            [translateParams]="{ amountSelected: this.selectedItems?.length || 0 }"
          >
          </div>
        </se-fe-grid-cell>
        <se-fe-grid-cell seFeGridOpts="shrink">
          <se-fe-modal-button
            [seFeDataButton]="{ label: 'Cancel', cancel: true }"
            (seFeButtonAction)="resetSelection()">
          </se-fe-modal-button>
          <se-fe-modal-button
            [seFeDataButton]="{ label: 'Save', primary: true }"
            (seFeButtonAction)="saveSelection()">
          </se-fe-modal-button>
        </se-fe-grid-cell>
      </se-fe-grid>
    </div>
  </div>

</se-fe-modal>
</div>
}
